import store from '@speechki-frontend/core/store/store';

// core modules
import payment from '@speechki-frontend/core/payment/store';
import book, { contractors } from '@speechki-frontend/core/book/store';
import { createPagedBookpartsStore } from '@speechki-frontend/core/editor/store/bookparts';

import { initEditorStore } from '@speechki-frontend/core/editor/store';

// specific modules
createPagedBookpartsStore(store);

store.registerModule('payment', payment);
store.registerModule('book', book);
store.registerModule('contractors', contractors);

initEditorStore(store);

export default store;
